<div class="dashboard--module-header">
    <h2 class="subheading-sm">Estimated bills<button class="info-btn focus-element" (click)="onInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
</div>
<div class="module--main">
    <issues-latest-bill-estimated-chart class="block-chart"></issues-latest-bill-estimated-chart>
    <div class="block-detail">
        <table class="std-table stacked-sm" *ngIf="data.length > 0">
            <thead>
            <th>Consumer name</th>
            <th>Supply address</th>
            <th>Estimated bills in last 6 bills</th>
            <th>Latest actual bill date</th>
            <th>Billed to actual in last 12 months</th>
            </thead>
            <tbody>
                <tr *ngFor="let item of data">
                    <td data-label="Consumer name">{{item.consumerName}}</td>
                    <td data-label="Supply address">{{item.consumerAddress}}</td>
                    <td data-label="Estimated bills in last 6 bills">{{item.esimtatedBills}}</td>
                    <td data-label="Latest actual bill date" *ngIf="isValidDate(item)">{{item.latestedNonEstimatedBill | date:'dd/MM/yyyy'}}</td>
                    <td data-label="Latest actual bill date" *ngIf="!isValidDate(item)">Never</td>
                    <td data-label="Billed to actual in last 12 months">{{item.nonCompliant == 0 ? 'Yes' : 'No'}}</td>
                    <td class="text-right"><a [routerLink]="['/portal/'+ clientId +'/consumer',item.consumerId]" class="text-link focus-element"><span class="focus--content">View</span></a></td>
                </tr>
            </tbody>
        </table>
        <app-pagination *ngIf="data.length > 0" [page]="page" [pages]="totalPages" (pageChange)="getPage($event)"></app-pagination>
    </div>
</div>
